
import React,{ useState, useReducer } from 'react';
import CardComponent from '../CardComponent';
import FileComponent from '../FileComponent'
export default function BannerBomb3CustomComponent(props) {
    const [status, setStatus] = useReducer((status, msg)=>{return status.concat([msg]); },[]);
    const [movableLoaded, setMovableLoaded] = useState(false);
    const [keyy, setKeyy] = useState(null);
    const [payload, setPayload] = useState([]);
    const [buildWorker, setBuildWorker] = useState(null);

  let handleBWMessage=(msg)=> {
    switch(msg.data.cmd) {
        case "addStatus":
          onStatus(msg.data.val.msg, msg.data.val.color);
          break;
        case "download":
            props.onDownload(msg.data.val.fname,msg.data.val.content);
            break;
        default:
            console.log("unknown message from worker "+msg.data.val.msg);
            break;
                  
    }
}
  let onStatus=(statusMessage, type)=>
  {
    setStatus({msg: statusMessage, type:type});
  }
  let buildDSiWare=()=>{
    if (payload === []) {
      return;
    }
    if (buildWorker != null && typeof(buildWorker) != "undefined") {
        buildWorker.terminate();
    }
    let newBuildWorker = new Worker("../Workers/DSiWareBuilder.js");
    newBuildWorker.addEventListener('message', handleBWMessage);
    newBuildWorker.postMessage(
        {
            cmd:"payload",
            val:{payload: payload }
        })
        //newBuildWorker.postMessage({cmd:"addFile",val:{filename:"usm.bin",url:"/data/usm.bin"}});
        newBuildWorker.postMessage({cmd:"start",val:{referrer: document.referrer, keyy: keyy}});
    setBuildWorker(newBuildWorker);

}
  return (
        <CardComponent status={status} title="Bannerbomb3 Custom Exploit Injector">
        <FileComponent hint='Do not choose "movable_part1.sed"' id="movable" defaultFilename="movable.sed" filter=".sed" onStatus={onStatus} 
            onPreValidate={(data)=>{
              setMovableLoaded(false);
              setKeyy(null);

            return {ok:(data.size===288 || data.size === 320 || data.size===16), msg: "Incorrect filesize for chosen movable.sed"}
          }} 
          onPostValidate={data=>{
            return true;
          }}
          onLoaded={data=>{
            setMovableLoaded(true);
            if (data.byteLength > 16) {
              setKeyy(new Uint8Array(data.slice(0x110,0x120)));
            }else {
              setKeyy(new Uint8Array(data.slice(0,16)));
            }
          }} />
        <FileComponent hint='bb3payload.bin' id="payload" defaultFilename="bb3payload.bin" filter=".bin" onStatus={onStatus} 
          onPreValidate={(data)=>{
            setPayload([]);
            return {ok:(data.size===256), msg: "Incorrect filesize for chosen bb3 payload. expected 256 bytes."}
          }} 
          onPostValidate={data=>{
            return data.byteLength === 256;
          }}
          onLoaded={data=>{
              setPayload(Array.from(new Uint8Array(data)));
          }} />
            <div className="form-group">
                <input type="button" id="build" value="Build and Download" disabled={!movableLoaded} onClick={(e)=>{
                  buildDSiWare();
                }} className={(movableLoaded === true)?"btn btn-success":"btn btn-secondary"} />
            </div>
        </CardComponent>
  );
}


